import { Carousel } from 'react-responsive-carousel';
import Flags from '../flags';
import objectFitImages from 'object-fit-images';
import PropTypes from 'prop-types';
import React from 'react';
import SlideWrapper from './slide-wrapper';

import './mini-slideshow.scss';

class SlideShow extends React.Component {
  constructor(props){
    super(props);
    this.state ={
      slides: [],
      loadSlides: true,
      css: props.listing.isIdx ? 'idx' : ''
    };
    this.updateSlides = this.updateSlides.bind(this);
  }

  getListingSlides() {
      if (!this.props.listing || !this.props.listing.listingImages) {
        return [];
      }
      return this.props.listing.listingImages.filter(i => i !== null);
  }

  updateSlides(){
    if(this.state.loadSlides){
      const images = this.getListingSlides();
      const slides = images.map((item, index) => {
        return (
          <SlideWrapper
            sizes={this.props.sizes}
            isSir={this.props.listing.isSir}
            css={this.state.css}
            key={index}
            index={index}
            item={item}
            link={this.props.link}
            showImage={true}
            listing={this.props.listing}
            buildGlobalDetailPage={this.props.buildGlobalDetailPage}/>
            
        );
      });
      this.setState({slides: slides, loadSlides: false});
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      slides: [],
      loadSlides: true,
      qs: nextProps.listing.isSir ? '?height=533' : '',
      css: nextProps.listing.isIdx ? 'idx' : ''
    });
    objectFitImages();
  }

  addAdditionalPropsToSlide = (item, { isSelected }) => {
    return React.cloneElement(item, { isSelected: isSelected });
  }

  render() {

    if (!this.props.listing.listingImages) {
      return;
    }
    if(this.state.slides.length === 0){
      var start = 0;
      var images = this.getListingSlides();
      var slides = images.map(function (item, index) {
        start++;
        return (
          <SlideWrapper
            sizes={this.props.sizes}
            isSir={this.props.listing.isSir}
            css={this.state.css}
            index={index}
            key={this.props.listing.identifier + index}
            item={item}
            link={this.props.link}
            globalListingLink={this.props.listing.listingLink}
            showImage={start <= 1}
            listing={this.props.listing}
            buildGlobalDetailPage={this.props.buildGlobalDetailPage}/>
        );
      }.bind(this));
      if (slides.length === 0) {
        slides = [(
          <div
            className={'slide'}
            key='placeholder'
            style={{backgroundImage: 'url(/img/s-grey.png)'}}>
            <img src={'/img/listing/transparent.png'} alt='placeholder' />
          </div>
        )];
      }
    }
    return (
      <div className="mini-slideshow-wrapper">
        <Flags listing={this.props.listing} flagData={this.props.flagData}/>
        <Carousel
          axis="horizontal"
          className={'detail-slider'}
          showArrows={true}
          infiniteLoop={true}
          showIndicators={false}
          showThumbs={false}
          renderItem={this.addAdditionalPropsToSlide}
          onChange={this.updateSlides}
        >
          {this.state.slides.length > 0 ? this.state.slides : slides}
        </Carousel>
        <div className="mini-slideshow-controls">
        </div>
      </div>
    );
  }
}

SlideShow.propTypes = {
  link: PropTypes.string,
  listing: PropTypes.object.isRequired,
  sizes: PropTypes.string
};

export default SlideShow;



// WEBPACK FOOTER //
// ./src/components/search/result/mini-slideshow/index.js